export const marketplaceKeys = {
  all: ["marketplace"] as const,
  listing: (searchKey: string, page: number) =>
    [...marketplaceKeys.all, "listing", searchKey, page] as const,
  searchSuggestions: (key: string) =>
    [...marketplaceKeys.all, "search-suggestions", key] as const,
  productDetails: (code: string) =>
    [...marketplaceKeys.all, "product-details", code] as const,
};
